var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReleaseAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11877_12299)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81485 1.85292C9.33393 1.32821 11.0033 2.14561 11.5335 3.67985L13.7362 10.0531C14.2419 11.5167 13.477 13.1091 12.0279 13.6099L7.37692 15.2173C5.85778 15.7422 4.18848 14.9247 3.65822 13.3904L1.45561 7.01711C0.949834 5.55364 1.71407 3.96156 3.16295 3.46062L7.81485 1.85292Z",
    fill: "url(#paint0_linear_11877_12299)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_11877_12299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3004 11.5586L9.21848 11.9325C8.31119 12.246 7.31335 12.1589 6.47419 11.6927C5.74637 11.2884 5.19344 10.6296 4.92149 9.84274L4.12975 7.55184C3.82669 6.67492 4.25983 5.72961 5.09732 5.44018L7.78538 4.51118C8.66339 4.20774 9.63716 4.7064 9.95488 5.62575L11.2722 9.43751C11.5753 10.3144 11.1412 11.268 10.3004 11.5586Z",
    fill: "#E46800"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.66823,
    y: -0.083725,
    width: 19.5418,
    height: 21.4756
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.06px)",
      clipPath: "url(#bgblur_1_11877_12299_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.12035,
    d: "M17.0042 14.2056C17.0042 15.8506 15.6837 17.1858 14.053 17.186H8.9729C7.26562 17.186 5.87427 15.7867 5.87427 14.064L5.87427 7.11572C5.87427 5.47081 7.20085 4.12274 8.83813 4.12256L13.5774 4.12256L13.6116 4.12939C13.6223 4.13402 13.6318 4.14123 13.6399 4.1499L16.9807 7.74365C16.9955 7.75953 17.0042 7.78056 17.0042 7.80225V14.2056Z",
    fill: "#FFCBB9",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_11877_12299)",
    strokeWidth: 0.171681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39954 9.50049H12.3995",
    stroke: "#FFF1E8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39954 12.5005H14.3995",
    stroke: "#FFF1E8",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11877_12299",
    x: 0.771141,
    y: 1.16042,
    width: 13.8596,
    height: 14.2192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63097,
    result: "effect1_foregroundBlur_11877_12299"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11877_12299_clip_path",
    transform: "translate(-1.66823 0.083725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0042 14.2056C17.0042 15.8506 15.6837 17.1858 14.053 17.186H8.9729C7.26562 17.186 5.87427 15.7867 5.87427 14.064L5.87427 7.11572C5.87427 5.47081 7.20085 4.12274 8.83813 4.12256L13.5774 4.12256L13.6116 4.12939C13.6223 4.13402 13.6318 4.14123 13.6399 4.1499L16.9807 7.74365C16.9955 7.75953 17.0042 7.78056 17.0042 7.80225V14.2056Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11877_12299",
    x1: 6.13771,
    y1: 2.43255,
    x2: 10.217,
    y2: 14.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11877_12299",
    x1: 7.70451,
    y1: 5.71038,
    x2: 16.1057,
    y2: 14.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11877_12299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseAnnouncement);
export default __webpack_public_path__ + "static/media/releaseAnnouncement.9355b7125f4cd93881f56cbbaddb79d6.svg";
export { ForwardRef as ReactComponent };